import Vue from 'vue';
import axios from 'axios';
import Router from 'vue-router';
import {store} from '../store/store.js';
import swal from 'sweetalert2'
import Dashboard from '@/pages/Dashboard';
import Status from '@/pages/Status';
import CacheTestClient from '@/pages/CacheTestClient';
import Error from '@/pages/Error';
import Apm from '@/pages/Apm';
import SubPageTwo from '@/pages/SubPageTwo';
import Transactions from '@/pages/Transactions';
import TransactionGroup from '@/pages/TransactionGroup';
import ClassificationPlan from '@/pages/ClassificationPlan';
import ClassificationPlanEntry from '@/pages/ClassificationPlanEntry';
import ClassificationPlanReview from '@/pages/ClassificationPlanReview';
import DocumentSearch from '@/pages/DocumentSearch';
import DocumentSearchFullText from '../pages/DocumentSearchFullText';
import DocumentSearchDetailed from '@/pages/DocumentSearchDetailed';
import DocumentSearchTectonical from '@/pages/DocumentSearchTectonical';
import DocumentSearchQuery from '@/pages/DocumentSearchQuery';
import ClassificationPlanPrint from '@/pages/ClassificationPlanPrint';
import DocumentDetails from '@/pages/DocumentDetails';
import DocumentInLongTermStorageDetails from '../pages/DocumentInLongTermStorageDetails';
import UploadDocumentInLongTermStorageFormat from '../pages/UploadDocumentInLongTermStorageFormat';
import KandidatiZaIzrocanje from '../pages/KandidatiZaIzrocanje';
import IzrocenoGradivo from '../pages/IzrocenoGradivo';
import RocniVnosStatusaPrevzemaPaketa from '../pages/RocniVnosStatusaPrevzemaPaketa';
import CacheInstanceEntry from "../pages/CacheInstanceEntry";
import AdminTools from "../pages/AdminTools";
import Models from "../pages/Models";
import Aspects from "../pages/Aspects";
import Properties from "../pages/Properties";
import DocumentDetailsEdit from '@/pages/DocumentDetailsEdit';
import DocumentDetailsEditTestClient from '@/pages/DocumentDetailsEditTestClient';
import DocumentEvipTestClient from '@/pages/DocumentEvipTestClient';
import DocumentCopyToEvipTestClient from '@/pages/DocumentCopyToEvipTestClient';
import ApmErrors from "@/pages/ApmErrors";
import ApmMetrics from "@/pages/ApmMetrics";
import ApmErrorGroup from "../pages/ApmErrorGroup";
import DocumentMetadataPrint from "../pages/DocumentMetadataPrint";
import UnclassifiedFilesReview from "../pages/UnclassifiedFilesReview";
import DocumentTestClient from "../pages/DocumentTestClient";
import AuditLog from "../pages/AuditLog";
import AuditLogExternal from "../pages/AuditLogExternal";
import AuditLogExternalImport from "../pages/AuditLogExternalImport";
import DocumentAddVersion from "../pages/DocumentAddVersion";
import DocumentListReview from "../pages/DocumentListReview";
import DocumentListPretecenRokHrambe from "../pages/DocumentListPretecenRokHrambe";
import DocumentList2 from "../pages/DocumentList2";
import DocumentList3 from "../pages/DocumentList3";
import DocumentList4 from "../pages/DocumentList4";
import DocumentList5 from "../pages/DocumentList5";
import DocumentListReviewSkrbnik from "../pages/DocumentListReviewSkrbnik";
import DocumentListLongTermStorage from "../pages/DocumentListLongTermStorage";
import Reports from "../pages/Reports";
import RegisterAdministration from "../pages/RegisterAdministration";
import PremikanjeRazredov from "../pages/PremikanjeRazredov";
import AlfrescoShareBrowser from "../pages/AlfrescoShareBrowser";
import Unauthorized from "../pages/Unauthorized";
import RegisterAuditLog from "../pages/RegisterAuditLog";
import MQtestClient from "../pages/MQtestClient";
import PackageExport from "../pages/PackageExport";

Vue.use(Router);


let router = new Router({
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/stanje-sistema',
            name: 'Status',
            component: Status,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/predpomnilnik/:id?',
            name: 'Cache',
            component: CacheInstanceEntry,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/predpomnilnik-testni-klient/:id?',
            name: 'CacheTestClient',
            component: CacheTestClient,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/napaka',
            name: 'Napaka',
            component: Error,
        },
        {
            path: '/apm',
            name: 'Apm',
            component: Apm,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/transactions/:serviceName',
            name: 'Transactions',
            component: Transactions,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/transactions/:serviceName/:transactionGroup',
            name: 'TransactionGroup',
            component: TransactionGroup,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/errors/:serviceName',
            name: 'ApmErrors',
            component: ApmErrors,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/errors/:serviceName/:errorGroup',
            name: 'ApmErrorGroup',
            component: ApmErrorGroup,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/metrics/:serviceName',
            name: 'ApmMetrics',
            component: ApmMetrics,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_SISTEMA']
            }
        },
        {
            path: '/classificationPlan/:expandAll?',
            name: 'ClassificationPlan',
            component: ClassificationPlan,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_KLASIF']
            }
        },
        {
            path: '/classificationPlan/:ClassificationPlanEntryType/:className',
            name: 'addClassificationPlanEntry',
            component: ClassificationPlanEntry,
            meta: {
                requiresAuth: true,
                requiresPermission: ['UREJANJE_KLASIF']
            }
        },
        {
            path: '/classificationPlanReview',
            name: 'ClassificationPlanReview',
            component: ClassificationPlanReview,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_KLASIF']
            }
        },
        {
            path: '/ClassificationPlanPrint',
            name: 'ClassificationPlanPrint',
            component: ClassificationPlanPrint,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_KLASIF']
            }
        },
        {
            path: '/unclassifiedFilesReview',
            name: 'UnclassifiedFilesReview',
            component: UnclassifiedFilesReview,
            meta: {
                requiresAuth: true,
                requiresPermission: ['DOST_DOK_NEKLASIF']
            }
        },
        {
            path: '/iskanjeDokumentov',
            name: 'DocumentSearch',
            component: DocumentSearch,
            meta: {
                requiresAuth: true,
                requiresPermission: ['ISCI_DOK_IN_META']
            }
        },
        {
            path: '/iskanjeDokumentov/iskanjePoPolnemTekstu/:queryParam?',
            name: 'DocumentSearchFullText',
            component: DocumentSearchFullText,
            meta: {
                requiresAuth: true,
                requiresPermission: ['ISCI_DOK_IN_META']
            }
        },
        {
            path: '/iskanjeDokumentov/iskanjePoPoljih',
            name: 'DocumentSearchDetailed',
            component: DocumentSearchDetailed,
            meta: {
                requiresAuth: true,
                requiresPermission: ['ISCI_DOK_IN_META']
            }
        },
        // REMOVED (ticket: EH-1895)
        // {
        //     path: '/iskanjeDokumentov/iskanjePoVsebiniKlasifikacijskegaNacrta',
        //     name: 'DocumentSearchTectonical',
        //     component: DocumentSearchTectonical,
        //     meta: {
        //         requiresAuth: true,
        //         requiresPermission: ['ISCI_DOK_IN_META']
        //     }
        // },
        {
            path: '/iskanjeDokumentov/iskanjePoDeskriptorjih/:queryParam?',
            name: 'DocumentSearchQuery',
            component: DocumentSearchQuery,
            meta: {
                requiresAuth: true,
                requiresPermission: ['ISCI_DOK_IN_META']
            }
        },
        {
            path: '/dokument/:id?',
            name: 'DocumentDetails',
            component: DocumentDetails,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['DOST_DOK_IN_META', 'DOST_DOK_ARHIV']
            }
        },
        {
            path: '/pretvorjeno-gradivo/:id',
            name: 'DocumentInLongTermStorageDetails',
            component: DocumentInLongTermStorageDetails,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['LAHKO_PRETVARJA_DOKUMENTE']
            }
        },
        {
            path: '/nalozi-pretvorjeno-gradivo/:id',
            name: 'UploadDocumentInLongTermStorageFormat',
            component: UploadDocumentInLongTermStorageFormat,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['LAHKO_PRETVARJA_DOKUMENTE']
            }
        },
        {
            path: '/kandidati-za-izrocanje/',
            name: 'KandidatiZaIzrocanje',
            component: KandidatiZaIzrocanje,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['IZDELAJ_PAKET_ZA_PRENOS']
            }
        },
        {
            path: '/izroceno-gradivo/',
            name: 'IzrocenoGradivo',
            component: IzrocenoGradivo,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['POROCILO_IZVOZ']
            }
        },
        {
            path: '/dokument-dodajanaje-verzije/:id?',
            name: 'DocumentAddVersion',
            component: DocumentAddVersion,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['POSR_DOK_IN_META']
            }
        },
        {
            path: '/dokument-urejanje/:id?',
            name: 'DocumentDetailsEdit',
            component: DocumentDetailsEdit,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['UREDI_META', 'UREDI_ROKE_ENOTE_GRADIVA']
            }
        },
        {
            path: '/dokument-evip/:id?',
            name: 'DocumentEvipTestClient',
            component: DocumentEvipTestClient,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: []
            }
        },
        {
            path: '/dokument-copy-to-evip/:id?',
            name: 'DocumentCopyToEvipTestClient',
            component: DocumentCopyToEvipTestClient,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: []
            }
        },
        {
            path: '/dokument-urejanje-testni-klient/:id?',
            name: 'DocumentDetailsEditTestClient',
            component: DocumentDetailsEditTestClient,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['UREDI_META', 'UREDI_ROKE_ENOTE_GRADIVA']
            }
        },
        {
            path: '/testni-klient/:id?',
            name: 'DocumentTestClient',
            component: DocumentTestClient,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['POSR_DOK_IN_META']
            }
        },
        {
            path: '/dokument-tiskanje/:id',
            name: 'DocumentMetadataPrint',
            component: DocumentMetadataPrint,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['TISKANJE_META']
            }
        },
        {
            path: '/seznam-gradiva-s-pretecenim-rokom-hrambe',
            name: 'DocumentListPretecenRokHrambe',
            component: DocumentListPretecenRokHrambe,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_IZLOCANJE_UNICENJE']
            }
        },
        {
            path: '/seznam-gradiva-za-pregledovanje',
            name: 'DocumentListReview',
            component: DocumentListReview,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_IZLOCANJE_UNICENJE']
            }
        },
        {
            path: '/seznam-gradiva-za-pregledovanje-skrbnik',
            name: 'DocumentListReviewSkrbnik',
            component: DocumentListReviewSkrbnik,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['SEZNAM_DODELJENI_ZA_PREGLED']
            }
        },
        {
            path: '/seznam-2',
            name: 'DocumentList2',
            component: DocumentList2,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['SEZNAM_POTRJENI_ZA_UNICENJE']
            }
        },
        {
            path: '/seznam-3',
            name: 'DocumentList3',
            component: DocumentList3,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['SEZNAM_ODBIRANJE_IZROCANJE']
            }
        },
        {
            path: '/seznam-4',
            name: 'DocumentList4',
            component: DocumentList4,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['SEZNAM_KANDIDATI_ZA_UNICENJE']
            }
        },
        {
            path: '/seznam-5',
            name: 'DocumentList5',
            component: DocumentList5,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['SEZNAM_POTRJENE_ZA_IZLOCANJE']
            }
        },
        {
            path: '/seznam-gradiva-za-dolgorocno-hrambo',
            name: 'DocumentListLongTermStorage',
            component: DocumentListLongTermStorage,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['LAHKO_PRETVARJA_DOKUMENTE']
            }
        },
        {
            path: '/rocni-vnos-statusa-prevzema',
            name: 'RocniVnosStatusaPrevzemaPaketa',
            component: RocniVnosStatusaPrevzemaPaketa,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['IZDELAJ_PAKET_ZA_PRENOS']
            }
        },
        {
            path: '/iskanje-po-revizijski-sledi/:uuid?',
            name: 'AuditLog',
            component: AuditLog,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_REVIZ_SLED']
            }
        },
        {
            path: '/zunanja-revizijska-sled/',
            name: 'AuditLogExternal',
            component: AuditLogExternal,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_REVIZ_SLED']
            }
        },
        {
            path: '/uvoz-zunanje-revizijske-sledi/',
            name: 'AuditLogExternalImport',
            component: AuditLogExternalImport,
            meta: {
                requiresAuth: true,
                requiresPermission: ['UVOZ_REVIZ_SLED']
            }
        },
        {
            path: '/revizijska-sled-sifrantov/',
            name: 'RegisterAuditLog',
            component: RegisterAuditLog,
            meta: {
                requiresAuth: true,
                requiresPermission: ['PREGLED_REVIZ_SLED']
            }
        },
        {
            path: '/admin-tools',
            name: 'adminTools',
            component: AdminTools,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/models',
            name: 'Models',
            component: Models,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {

            path: '/registerAdministration',
            name: 'registerAdministration',
            component: RegisterAdministration,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['OSTALA_SIST_OPRAVILA']
            }

        },
        {

            path: '/mq-test-client',
            name: 'mqTestClient',
            component: MQtestClient,
            props: true,
            meta: {
                requiresAuth: true,
                requiresPermission: ['OSTALA_SIST_OPRAVILA']
            }

        },
        {
            path: '/aspects',
            name: 'Aspects',
            component: Aspects,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/properties',
            name: 'Properties',
            component: Properties,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/subpage-two',
            name: 'SubPageTwo',
            component: SubPageTwo,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/porocila',
            name: 'Reports',
            component: Reports,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/premikanje-razredov',
            name: 'PremikanjeRazredov',
            component: PremikanjeRazredov,
            meta: {
                requiresAuth: true,
                requiresPermission: ['OSTALA_SIST_OPRAVILA']
            }
        },
        {
            path: '/alfresco-share',
            name: 'AlfrescoShareBrowser',
            component: AlfrescoShareBrowser,
            meta: {
                requiresAuth: true,
                requiresPermission: ['OSTALA_SIST_OPRAVILA']
            }
        },
        {
            path: '/nedovoljen-dostop-do-vsebine',
            name: 'Unauthorized',
            component: Unauthorized,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/package-export',
            name: 'PackageExport',
            component: PackageExport,
            meta: {
                requiresAuth: true,
                requiresPermission: ['OSTALA_SIST_OPRAVILA']
            }
        },
    ],
    mode: 'hash',
});


router.beforeEach((to, from, next) => {

    const locale =  Vue.prototype.i18n._vm.locale;
    const messages = Vue.prototype.i18n._vm.$root.messages[locale];

    let requiresPermission = to.matched[0] && to.matched[0].meta.requiresPermission ? to.matched[0].meta.requiresPermission : false;

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (router.app.$keycloak.authenticated) {
            if (!requiresPermission || requiresPermission.length === 0) {
                store.dispatch('cancelPendingRequests').then(() => {
                    if(Vue.prototype.$globalFunctions.checkIfRouteIsBlockedInProductionEnv(to)) {
                        console.log("--------> HERE1!!!!");
                        router.push({name: 'Unauthorized'}).catch(()=>{});
                    } else {
                        next();
                    }
                });
            } else {
                let hasPermissions = false;
                let p1 = store.dispatch("retrievePermissions");

                Promise.all([p1]).then((values) => {
                    _.map(requiresPermission, function (val) {

                        console.log("requiresPermission", requiresPermission);
                        console.log("VAL ----> ", val);

                        if (Vue.prototype.$globalFunctions.checkForPermission(val)) {
                            hasPermissions = true;
                            return false;
                        }
                    });
                }).then(() => {
                    if (hasPermissions) {
                        store.dispatch('cancelPendingRequests').then(() => {
                            if(Vue.prototype.$globalFunctions.checkIfRouteIsBlockedInProductionEnv(to)) {
                                console.log("--------> HERE2!!!!");
                                router.push({name: 'Unauthorized'}).catch(()=>{});
                            } else {
                                next();
                            }
                        });

                    } else {
                        console.log("Router: ", "Dostop ni dovoljen.");

                        swal.fire({
                            title: messages.text.globals.warningTitle,
                            icon: 'warning',
                            type: 'warning',
                            dangerMode: false,
                            html: messages.text.router.accessDeniedSwal,
                            showCloseButton: true,
                            showCancelButton: false,
                            focusConfirm: false,
                        });


                    }
                });
            }
        } else {
            const loginUrl = router.app.$keycloak.createLoginUrl()
            window.location.replace(loginUrl)
        }
    } else {
        store.dispatch('cancelPendingRequests').then(() => {
            if(Vue.prototype.$globalFunctions.checkIfRouteIsBlockedInProductionEnv(to)) {
                console.log("--------> HERE3!!!!");
                router.push({name: 'Unauthorized'}).catch(()=>{});
            } else {
                next();
            }
        });
    }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js